import axios from '@/utils/http';

export default (id, lang = 'en') => {
  const langObj = {
    'zh-cn': 'zh-CN',
    en: 'en',
  };
  lang = langObj[lang] || 'en';
  return axios
    .get(`/evaluation/${id}/tags`, {
      params: {
        lang,
      },
    })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
